<template>

  <!-- Join Team Element -->
  <page-block
    :class="{odd}"
    class="join-team-element"
    overlay-class="q-py-none"
    :bg-color="value.bgColor"
    :text-color="value.textColor"
    :text-align="value.textAlign"
    wrapper-class="column row-sm items-sm-center justify-center">

    <!-- Group Button -->
    <q-btn
      rounded
      size="lg"
      unelevated
      v-if="joined"
      color="secondary"
      @click="$refs.dialog.show()"
      class="join-team-element__group-button full">

      <span
        class="join-team-element__button-text">
        Participants
      </span>

      <q-icon
        name="fa lni-users"/>

    </q-btn>

    <template
      v-else>

      <!-- Join Button -->
      <q-btn
        rounded
        size="lg"
        unelevated
        @click="join"
        color="primary"
        :loading="loading"
        :disable="!seats || loading"
        class="join-team-element__join-button">

        <div
          class="join-team-element__button-text">
          Join Chef's Team
        </div>

        <span
          class="join-team-element__counter-text">
          {{ seats }}
        </span>

        <span
          class="join-team-element__seats-text">
          seats<br/>
          left
        </span>

      </q-btn>

      <div
        class="q-px-mm q-py-ss"/>

      <!-- Group Button -->
      <q-btn
        rounded
        size="lg"
        unelevated
        color="secondary"
        @click="$refs.dialog.show()"
        class="join-team-element__group-button">

        <q-icon
          name="fa lni-users"/>

      </q-btn>

    </template>

    <team-dialog
      ref="dialog"
      @join="join"
      :users="users"
      :loading="loading"
      :image="value.file"
      :can-join="seats && !joined"/>

  </page-block>

</template>

<script>

  import {Notify} from 'quasar';
  import {mapState, mapActions} from 'vuex';
  import PageBlock from '@src/components/page/page-block';
  import TeamDialog from '@src/components/dialog/team-dialog';

  export default {
    name: 'join-team-element',
    props: {
      value: {
        type: Object,
        required: true,
      },
      odd: {
        required: false,
      },
    },
    components: {
      PageBlock,
      TeamDialog,
    },
    computed: {
      ...mapState('vlVendors', {
        vendor: 'item',
      }),
      ...mapState('session', {
        user: 'user',
        loading: 'loading',
      }),
      users() {

        return this.vendor
          && this.vendor.users || [];
      },
      seats() {

        if (!this.vendor)
          return 0;

        const left = (this.vendor.seats || 0)
          - this.vendor.users.length;

        return left > 0
          ? left
          : 0;
      },
      joined() {

        return this.vendor
          && this.user.vendorId === this.vendor.id;
      },
    },
    methods: {
      ...mapActions('session', {
        setVendor: 'SELECT_VENDOR',
      }),
      join() {

        if (!this.vendor)
          return Notify.create({
            message: 'No Chef found',
            color: 'negative',
          });

        this.setVendor(
          this.vendor.id,
        );
      },
    },
  };

</script>

<style lang="scss">

  .join-team-element {
    color: inherit;

    &__join-button.disabled {
      background-color: grey !important;
    }

    &__group-button {
      min-width: 120px;
    }

    &__button-text {
      margin-right: .7rem;
      text-transform: lowercase;
      font-weight: bold !important;
    }

    &__counter-text {
      font-size: 1.4em;
      margin-right: .4rem;
      vertical-align: middle;
      font-weight: bold !important;
    }

    &__seats-text {
      font-size: 11px;
      line-height: 14px;
      vertical-align: middle;
      text-transform: lowercase;
      font-weight: bold !important;
    }

    @media (min-width: $breakpoint-xs-max) {

      &__join-button {
        width: 300px;
      }

      &__group-button.full {
        width: 250px;
      }
    }
  }

</style>
